/**
 * ColorPicker  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { ISchemaStringWithConstConstItem } from "@adapptio/lib-blueprint";
import { ColorPickerContext } from "./ColorPickerContext";
import { useDeepCompareMemo } from "use-deep-compare";

import "./ColorPicker.scss";

export interface IColorPickerProps {
	value?: string;
	palette?: ISchemaStringWithConstConstItem[];
	onChange?: (value: string) => void;
	onClose?: () => void;
}

export const ColorPicker: React.FC<IColorPickerProps> = ({ children, value, palette, onChange, onClose }) => {
	const valueFromPalette = useDeepCompareMemo(
		() => [ ...(palette || []) ].find((item) => item.label.toLowerCase() === value.toLowerCase())?.value,
		[ palette, value ]
	);
	const pickedColor = useDeepCompareMemo(() => valueFromPalette || value, [ valueFromPalette, value ]);

	return (
		<ColorPickerContext.Provider
			value={{ palette, value, valueFromPalette, pickedColor, onChange, onClose }}
		>
			{children}
		</ColorPickerContext.Provider>
	);
};
